import { render, staticRenderFns } from "./myaibot.vue?vue&type=template&id=feb9619e&scoped=true&"
import script from "./myaibot.vue?vue&type=script&lang=js&"
export * from "./myaibot.vue?vue&type=script&lang=js&"
import style0 from "./myaibot.vue?vue&type=style&index=0&id=feb9619e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb9619e",
  null
  
)

export default component.exports